import type { IValidatedResponse } from '../../httpClient';
import { postRequest } from '../../httpClient';
import type { IGenerateChallengeBody } from './generate-challenge-request';
import type { IGenerateChallengeResponse } from './generate-challenge-response';
import { generateChallengeResponseSchema } from './generate-challenge-response';

export async function generateChallengeApi(
  body: IGenerateChallengeBody,
): Promise<IValidatedResponse<IGenerateChallengeResponse>> {
  return postRequest<IGenerateChallengeResponse>({
    path: '/sys/challenges/generate',
    body,
    schema: generateChallengeResponseSchema,
  });
}
